import React, { useState } from 'react';
import { FaFacebookSquare, FaInstagram, FaTwitter } from 'react-icons/fa';
import { useForm } from 'react-hook-form';

const Footer = ({ countryCode }) => {


  return (
    <div>
      <footer className="footer margin-top-60">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              {/* Dynamic Content */}
              {countryCode === 'IN' ? (
                <p>InstaApp Powered By STISSA TECHNOLOGY LLP</p>
              ) : (
                <p>Copyright © InstaApp {new Date().getFullYear()} All Rights Reserved</p>
              )}

              <ul className="footer_social text-center">
                <li>
                  <a href="https://www.facebook.com/instaapp/" target="_blank" rel="noopener noreferrer">
                    <FaFacebookSquare />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/instaapp.online/" target="_blank" rel="noopener noreferrer">
                    <FaInstagram />
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com/InstaApp1" target="_blank" rel="noopener noreferrer">
                    <FaTwitter />
                  </a>
                </li>
              </ul>
              <p>
                <a href="/privacy-policy" rel="noopener noreferrer">
                  Privacy Policy
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>

    </div>
  );
};

export default Footer;
